import { Modal, Form, Input, Table, message, Button, Row, Col, Space, Tag } from "antd"
import { baseUrlAREA, CREATE_DG, HEADERS_BASIC, LOAD_DG_HANDLE, UPDATE_PARCELNO } from "../../../API/apiUrlsNew";
import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { ReprintDemandGuaranter } from "../report/ReprintDemandGuaranter";
import { excelForPostOffice2 } from "../report/ExportPostOffice2";
// import { excelForPostOffice } from "../../cancelContract/export/ExportPostOffice";
// import { data } from "react-router-dom";

const AutoFocusInput = React.memo(({ record, index, fieldName, placeholder, onComplete, isError, clearError }) => {
    return (
        <Form.Item
            name={["rows", record.key, fieldName]}
            style={{ margin: 0 }}
            validateStatus={isError ? "error" : ""}
            rules={[{ len: 13, message: "13 หลัก", warningOnly: true }]}
            getValueFromEvent={(e) => e.target.value}
        >
            <Input
                id={`input-${fieldName}-${index}`}
                placeholder={placeholder}
                maxLength={13}
                status={isError ? "error" : ""}
                style={{ textAlign: 'center' }}
                onChange={(e) => {
                    const v = e.target.value.trim();
                    if (isError && clearError) clearError();
                    if (v.length === 13) onComplete(index, v);
                }}
            />
        </Form.Item>
    );
});

const ModalAddDG_Handle = ({ open, close, dataRecord }) => {
    const USERNAME = localStorage.getItem("USERNAME");

    const [form] = Form.useForm();
    const [displayData, setDisplayData] = useState([]);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
    const [errorMap, setErrorMap] = useState({});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [loading, setLoading] = useState(false);
    const [arrData, setArrData] = useState([]);
    const [datePicker, setDatePicker] = useState();
    const [masterData, setMasterData] = useState([]);
    const [completedCount, setCompletedCount] = useState(0);
    const [rangeStart, setRangeStart] = useState(1);
    const [rangeEnd, setRangeEnd] = useState(0);
    const [dataDB2, setDataDB2] = useState([]);
    const [dataDB2Filter, setDataDB2Filter] = useState([]);

    const [dataClose, setDataClose] = useState([]);


    const [arrayTable, setArrayTable] = useState([]);


    console.log("arrayTable", arrayTable);




    useEffect(() => {
        loadDataDemandGusranter();
    }, []);

    const handleClose = () => {
        close(false);
    }

    const changePage = (newPage, newPageSize) => {
        // saveCurrentPageToMaster();
        setPagination(prev => ({ ...prev, current: newPage, pageSize: newPageSize || prev.pageSize }));
    };



    const loadDataDemandGusranter = async () => {

        let data = {
            CONTNO: [dataRecord.CONTNO],
            company: '1',
            contractSchema: dataRecord.SCHEMA,
            date: dayjs().toISOString()
        }

        console.log("data", data);


        await axios.post(LOAD_DG_HANDLE, data,
            // await axios.get(`http://localhost:8070/api-inv/load-dg/2-0008106`,
            {
                headers: HEADERS_BASIC

            })
            .then((res) => {
                console.log("res", res.data);
                const data = res.data.mainData || [];
                setArrayTable(data);
                setMasterData(data);   // ✅ เพิ่มบรรทัดนี้
                if (res.status === 201) {
                    alert("ยังไม่ได้บันทึกข้อมูลจดหมายบอกกล่าว กรุณาบันทึกข้อมูลก่อน");
                    handleClose()
                }
                const rows = {};
                data.forEach(item => {
                    rows[item.key] = {
                        parcelNo: item.parcelNo || "",
                        parcelNoResponse: item.parcelNoResponse || ""
                    };
                });

                form.setFieldsValue({ rows });   // ✅ set ตรงนี้จบเลย
            })
            .catch((err) => {
                console.log("err", err);
            })
    }

    const onFinish = async () => {
        // setLoading(true);
        saveCurrentPageToMaster(); // อัปเดตข้อมูลล่าสุดเข้า masterData ก่อน


        // ดึงข้อมูลล่าสุดจริงๆ อีกทีหลัง saveCurrentPageToMaster ทำงานเสร็จ (ผ่าน getEffectiveData หรือรอ state update)
        // เพื่อความชัวร์ ใช้การ merge ตรงนี้เลย
        const currentFormValues = form.getFieldsValue().rows || {};

        const finalData = arrayTable.map(row => {
            const formRow = currentFormValues[row.key] || {};
            return { ...row, ...formRow };
        });

        const dataToSend = finalData.filter(item =>
            item.parcelNo &&
            item.parcelNoResponse &&
            item.parcelNo.length === 13 &&
            item.parcelNoResponse.length === 13
        );

        console.log("dataToSend", dataToSend);


        try {
            const res = await axios.post(UPDATE_PARCELNO, dataToSend, { headers: HEADERS_BASIC });
            if (res.status === 200) {
                message.success("บันทึกสำเร็จ");
                // if (refreshCalendar) refreshCalendar();
                loadDataDemandGusranter()
            }
        } catch (error) {
            if (error.response?.status === 409) {
                Modal.error({ title: 'บันทึกไม่สำเร็จ', content: `เลขซ้ำ: ${error.response.data.duplicateValue}` });
            } else {
                message.error("บันทึกผิดพลาด");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleInputComplete = (rowIndex, type, value) => {
        const pageSize = pagination.pageSize;
        const startIndex = (pagination.current - 1) * pageSize;

        const record = arrayTable[startIndex + rowIndex]; // ✅ เปลี่ยนตรงนี้
        if (!record) return;

        const rowKey = record.key;
        const fieldName = type === 'mail' ? 'parcelNo' : 'parcelNoResponse';

        const effectiveData = getEffectiveData();

        const isDuplicate = effectiveData.find(d =>
            (d.parcelNo === value && (d.key !== rowKey || fieldName !== 'parcelNo')) ||
            (d.parcelNoResponse === value && (d.key !== rowKey || fieldName !== 'parcelNoResponse'))
        );

        if (isDuplicate) {
            Modal.error({ title: 'เลขซ้ำ', content: `เลข ${value} ถูกใช้ไปแล้ว` });

            setErrorMap(prev => ({
                ...prev,
                [`${rowKey}-${fieldName}`]: true
            }));

            form.setFieldValue(["rows", rowKey, fieldName], null);
            return;
        }

        setErrorMap(prev => {
            const newMap = { ...prev };
            delete newMap[`${rowKey}-${fieldName}`];
            return newMap;
        });

        const currentItemsOnPage =
            arrayTable.slice(startIndex, startIndex + pageSize).length;

        // ===== AUTO MOVE =====
        if (type === 'mail') {
            document
                .getElementById(`input-parcelNoResponse-${rowIndex}`)
                ?.focus();
        } else {
            const nextRow = rowIndex + 1;

            if (nextRow < currentItemsOnPage) {
                document
                    .getElementById(`input-parcelNo-${nextRow}`)
                    ?.focus();
            } else {
                handleNextPageFocus();
            }
        }
    };

    const getEffectiveData = () => {
        const currentFormValues = form.getFieldsValue().rows || {};
        return masterData.map(row => {
            const formRow = currentFormValues[row.key] || {};
            return { ...row, ...formRow };
        });
    };

    const updateProgress = () => {
        const currentFormValues = form.getFieldsValue().rows || {};
        let count = 0;
        masterData.forEach(row => {
            const formRow = currentFormValues[row.key] || {};
            const pNo = formRow.parcelNo !== undefined ? formRow.parcelNo : row.parcelNo;
            const pRes = formRow.parcelNoResponse !== undefined ? formRow.parcelNoResponse : row.parcelNoResponse;
            if (pNo && pRes && pNo.length === 13 && pRes.length === 13) count++;
        });
        setCompletedCount(count);
    };

    const handleNextPageFocus = () => {
        const totalPages = Math.ceil(displayData.length / pagination.pageSize);
        if (pagination.current < totalPages) {
            changePage(pagination.current + 1);
            message.loading({ content: "ถัดไป...", key: 'pageLoad', duration: 0.5 });
            setTimeout(() => {
                const input = document.getElementById(`input-parcelNo-0`);
                if (input) input.focus();
            }, 300);
        } else {
            saveCurrentPageToMaster();
            message.success("จบรายการช่วงนี้แล้ว");
        }
    };

    const saveCurrentPageToMaster = () => {
        // 1. ดึงข้อมูลทั้งหมดจาก Form (Ant Design)
        const formValues = form.getFieldsValue();

        // 2. ดึงเฉพาะส่วนของ rows ออกมา ถ้าไม่มีให้เป็น Object ว่าง
        const rawRows = formValues.rows || {};

        // 3. ถ้าไม่มีการแก้ไขข้อมูลใดๆ ในหน้าปัจจุบัน (rawRows ว่าง) ให้หยุดการทำงานทันที
        if (Object.keys(rawRows).length === 0) return;

        // 4. แยก newData ออกมาคำนวณข้างนอก โดย Clone จาก masterData ชุดเดิม
        const newData = [...masterData];

        // 5. วนลูปเพื่อนำข้อมูลที่แก้ใน Form (rawRows) ไปอัปเดตลงใน newData
        Object.keys(rawRows).forEach((key) => {
            const rowData = rawRows[key];

            // ค้นหา Index ใน MasterData ที่มี key ตรงกัน
            const index = newData.findIndex((d) => String(d.key) === String(key));

            if (index > -1) {
                // อัปเดตข้อมูลแถวนั้นๆ โดยการ Merge ข้อมูลเดิมเข้ากับค่าใหม่จาก Form
                newData[index] = {
                    ...newData[index],
                    ...rowData
                };
            }
        });

        // 6. นำ newData ที่อัปเดตเรียบร้อยแล้วไปเก็บลง State
        setMasterData(newData);

        // 7. ส่ง newData ไปประมวลผลต่อที่ handleCheckClose ทันที
        // เพื่อให้ Logic การเช็คเงื่อนไขได้รับข้อมูลล่าสุด (ไม่ต้องรอ State อัปเดต)
        // handleCheckClose(newData, "filter");

        const sliceddb2 = newData.slice(rangeStart - 1, rangeEnd);
        // console.log("sliceddb2", sliceddb2)
        handleCheckClose(sliceddb2, "filter")
    };

    const handleCheckClose = (value, type) => {

        // console.log("valueCheckClose", value)
        // console.log("type", type)
        const trueList = [];
        const falseList = [];

        value.forEach((e) => {
            if (e.flagClose) {
                trueList.push(e);   // true
            } else {
                falseList.push(e);  // false/null/undefined
            }
        });

        if (type === "start") {
            setDataClose(trueList);
            setDataDB2(value ? value : []);
            setDataDB2Filter(falseList ? falseList : []);
        } else if (type === "filter") {
            setDataDB2Filter(falseList ? falseList : []);
        } else if (type === "reset") {
            setDataDB2Filter(falseList ? falseList : []);
        }

        // console.log("trueList", trueList)


        // setDataActive(falseList);

        // setDataDB2(value ? value : []);
        // setDataDB2Filter(falseList ? falseList : []);

        // setDataDB2Filter(dataDB2) // รีเซ็ท
        // setDataDB2Filter(dataDB2) // รีเซ็ท
    }




    const columns = useMemo(() => [
        {
            title: "ลำดับ",
            width: 70,
            align: "center",
            fixed: "left",
            render: (text, record, index) =>
                (pagination.current - 1) * pagination.pageSize + index + 1
        },
        { title: "สัญญา", dataIndex: "contractNo", width: 130, align: 'center' },
        // { title: "รอบออกจดหมาย", dataIndex: "roundDate", width: 180, ellipsis: true },
        {
            title: 'รอบออกบอกกล่าว',
            dataIndex: 'roundDate',
            align: "center",
            width: 100,
            ellipsis: true,
            render: (text, record) =>
                <>
                    <Tag color={'orange'}><b>{dayjs(record?.roundDate).format('DD-MM-YYYY')}</b></Tag>
                </>
        },
        {
            title: 'ชื่อ-นามสกุล',
            dataIndex: 'customerFullName',
            width: 250,
            align: "center",
            ellipsis: true,
            render: (text, record) =>
                <>
                    {`${record?.customerFullName}`} (คค.{record.customerTypeId})
                    {/* {`${record?.SNAM + record?.NAME1 + ' ' + record?.NAME2}`} (คค.{record.GARNO}) */}
                </>
        },
        {
            title: "EMS ไป", dataIndex: "parcelNo", width: 180, align: 'center',
            render: (_, r, i) => (
                <AutoFocusInput
                    record={r} index={i} fieldName="parcelNo" placeholder="EMS ไป"
                    isError={!!errorMap[`${r.key}-parcelNo`]}
                    clearError={() => setErrorMap(p => { const n = { ...p }; delete n[`${r.key}-parcelNo`]; return n; })}
                    onComplete={(idx, val) => handleInputComplete(idx, 'mail', val)}
                />
            )
        },
        {
            title: "EMS กลับ", dataIndex: "parcelNoResponse", width: 180, align: 'center',
            render: (_, r, i) => (
                <AutoFocusInput
                    record={r} index={i} fieldName="parcelNoResponse" placeholder="EMS กลับ"
                    isError={!!errorMap[`${r.key}-parcelNoResponse`]}
                    clearError={() => setErrorMap(p => { const n = { ...p }; delete n[`${r.key}-parcelNoResponse`]; return n; })}
                    onComplete={(idx, val) => handleInputComplete(idx, 'response', val)}
                />
            )
        }
    ]);

    const handleExportLetter = async () => {
        await ReprintDemandGuaranter(arrayTable, "new")
    }

    const handleSendPostEMS = async () => {
        await excelForPostOffice2(arrayTable, 1)
    }


    return (
        <Modal
            open={open}
            onCancel={handleClose}
            width={1200}
            footer={null}
            maskClosable={false}   // ✅ กันกดข้างนอกแล้วปิด
        >
            <Form form={form} component={false}>
                <Row justify={'end'} gutter={16} style={{ marginBottom: 16, marginTop: 30 }}>
                    <Col>
                        <Space>
                            <Button
                                onClick={onFinish}
                                // type="primary"
                                style={{ color: "green" }}
                            >
                                บันทึก

                            </Button>
                            <Button
                                // onClick={insertData}
                                style={{ color: 'blue' }}
                                onClick={handleExportLetter}
                            // danger
                            >
                                พิมพ์จดหมายบอกกล่าว

                            </Button>
                            <Button
                                type="primary"
                                style={{ backgroundColor: "green", borderColor: "green", color: "white" }}
                                onClick={handleSendPostEMS}
                            >
                                Export ใบนำส่ง
                            </Button>

                        </Space>

                    </Col>
                </Row>
                <Table
                    rowKey="key"
                    columns={columns}
                    dataSource={arrayTable}
                    size="small"
                    bordered
                    scroll={{ y: 500, x: 800 }}
                    pagination={{
                        current: pagination.current,
                        pageSize: pagination.pageSize,
                        total: arrayTable.length,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100', '200'],
                        onChange: (p, s) => changePage(p, s),
                        showTotal: (total, range) => `${range[0]}-${range[1]} จาก ${total}`
                    }}
                    rowSelection={{ selectedRowKeys, onChange: setSelectedRowKeys }}
                    onRow={(record) => ({
                        style: {
                            backgroundColor: record.flagClose ? '#ffccc7' : 'inherit',
                        }
                    })}
                />
            </Form>

        </Modal>
    )
}

export default ModalAddDG_Handle